import { createAction } from '@reduxjs/toolkit';

/**
 * The signed-in user's own permissions were just changed (in user management)
 * and are being reloaded.
 *
 * Any slice holding state that a permission change can invalidate — contract
 * filters above all, which may now point at a contract the user no longer has
 * — resets itself in `extraReducers` on this action. Dispatching a shared
 * action instead of importing each app's reset keeps the feature-app boundary
 * intact: `common` does not have to know which apps care.
 */
export const currentUserPermissionsChanged = createAction(
  'app/currentUserPermissionsChanged'
);
